import { CombinedFieldProps } from "../../types/skyward/treebrowse";

export interface Emits
{
    recordDoubleClick: (data: CombinedFieldProps) => boolean;
    recordSelected: (rowData: CombinedFieldProps) => boolean;
    recordMounted: (row: HTMLElement) => boolean;
    breadcrumbClicked: (index: number) => boolean;
}

export const recordDoubleClick = "recordDoubleClick";
export const recordSelected = "recordSelected";
export const recordMounted = "recordMounted";
export const breadcrumbClicked = "breadcrumbClicked";
